export enum ErrorLogUploadType {
  REPORT_GENERATION = 'report-generation',
  STATEMENT_UPLOAD = 'statement-upload',
}
